import { render } from "./PopupCustom.vue?vue&type=template&id=8a288636"
import script from "./PopupCustom.vue?vue&type=script&lang=js"
export * from "./PopupCustom.vue?vue&type=script&lang=js"

import "./PopupCustom.vue?vue&type=style&index=0&id=8a288636&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__